module.exports = __webpack_public_path__ + "img/case-logo-49.49ecb8bf.png";